// extracted by mini-css-extract-plugin
export default {"main":"noVideo_main__t7RHM","exploreLink":"noVideo_exploreLink__DE70i","image":"noVideo_image__qaDcC"};